import React from 'react';
import './NoResults.css';

const Noresults = () => {
  return (
    <section className='noresults'>
      <h1>찾으시는 결과가 없네요..ㅠㅠ</h1>
      <h2>다른 키워드로도 검색해보세요!</h2>
    </section>
  );
};

export default Noresults;
